<template>
  <b-container>
    <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-modal ref="openModal" scrollable size="lg" @hide="cancel()" :title="$t('workflow.importProcess')">
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <b-form-group label="Anexo" label-for="file">
            <b-form-file :lang="$i18n.locale" id="file" ref="file" :placeholder="$t('geral.escolhaArquivo')"
              v-on:change="handleFileUpload($event)" :no-drop="true"></b-form-file>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-table ref="table" class="table-nowrap" :items="importResultsListSorted" :fields="importResultTable.fields">
          <!-- <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>{{ $t("geral.loadingData") }}</strong>
            </div>
          </template> -->
        </b-table>
        <!-- 
    public int LineNumber { get; set; }
    public bool Success { get; set; }
    public string Message { get; set; }
   -->
      </b-row>

      <!-- <b-button size="sm" @click="downloadLayout()">Baixar layout</b-button> -->
      <template #modal-footer="{ }">
        <div class="right">
          <b-button variant="green" @click="connectToSSE" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import axios from "axios";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "WorkflowImportModal",
  props: {
    processId: String,
  },
  components: {
    "success-fade-alert": SuccessFadeAlert,
    "fade-alert-danger": FadeAlertDanger,
  },
  data: function () {
    return {
      submitted: false,
      file: null,
      importacaoId: null,
      alert: {
        error: "",
        success: "",
      },
      latitude: 0.0,
      longitude: 0.0,
      abortController: null,
      importResultTable: {
        fields: [
          {
            key: "date",
            filterKey: "Date",
            label: "Data importação",
            // thStyle: "text-align: center; width: 180px;",
            tdClass: this.tdColor,
            formatter: (value) => {
              return this.formatDatetimePtBr(new Date(value));
            },
          },
          {
            key: "lineNumber",
            filterKey: "lineNumber",
            label: "Linha",
            // thStyle: "text-align: center; width: 180px;",
            tdClass: this.tdColor,
          },
          {
            key: "success",
            filterKey: "success",
            label: "Sucesso",
            // thStyle: "text-align: center; width: 120px;",
            tdClass: this.tdColor,
            formatter: (value) => {
              return value ? "Sucesso" : "Erro";
            },
          },
          {
            key: "message",
            filterKey: "message",
            label: "Mensagem",
            // thStyle: "text-align: center; width: 120px;",
            tdClass: this.tdColor,
          },
        ],
        items: [],
      }
    };
  },
  beforeDestroy() {
    this.disconnectFromSSE(); // Chama a função para desconectar antes de destruir o componente
  },
  computed: {
    importResultsListSorted() {
      return this.importResultTable.items.sort((a1, a2) => a2.lineNumber - a1.lineNumber)
    },
  },
  methods: {
    disconnectFromSSE() {
      console.log('disconnectFromSSE')
      console.log(this.abortController)
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      if (this.eventSource) {
        this.eventSource.close(); // Fecha a conexão SSE
        this.eventSource = null; // Limpa a referência ao objeto EventSource
      }
    },
    async connectToSSE() {
      try {
        this.submitted = true;
        this.importResultTable.items = [];

        console.log('INICIO');
        this.abortController = new AbortController();
        // const response = await axios.request({
        //   url: `${this.$store.getters.urlChecklist}/v6/checklist/save?returnAttachmentContent=false`,
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     Authorization: `Bearer ${this.$store.getters.token}`,
        //   },
        //   data: checklistFormData,
        // });
        const response = await fetch(
          `${this.$store.getters.urlWorkflow}/v2/importProcess/${this.processId}/${this.latitude}/${this.longitude}`,
          {
            signal: this.abortController.signal
          });
        const reader = response.body.getReader(); // Obtem um leitor assíncrono para o stream
        const decoder = new TextDecoder();

        while (true) {
          const { done, value } = await reader.read(); // Lê um chunk do stream de forma assíncrona
          if (done) break; // Se o stream terminar, sai do loop

          const chunk = decoder.decode(value); // Decodifica o chunk em texto
          if (chunk[0] == "[" || chunk[0] == ",")
            chunk = chunk.slice(1)
          if (chunk[chunk.length - 1] == "]")
            chunk = chunk.slice(0, -1)
          const eventData = JSON.parse(chunk); // Parseia o JSON
          this.importResultTable.items.push(eventData);
          // this.weatherForecasts.push(eventData); // Adiciona o evento recebido ao array de eventos
        }
        this.submitted = false;
      }
      catch (error) {
        console.log('Error CATCH!');
        console.log(error);
        // res.status(400).send(error.message);
        this.submitted = false;
      }
    },
    show() {
      this.$refs.openModal.show();
      this.getPosition();
    },
    save() {
      if (this.file != null) {
        this.submitted = true;
        let formData = new FormData();
        formData.append("file", this.file);
        this.$apiWorkflow
          .post(
            `/importProcess/${this.processId}/${this.latitude}/${this.longitude}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            this.$refs.openModal.hide();
            this.alert.success = "Processo importado com sucesso!";
            this.$refs.successFadeAlert.show();
            this.file = null;
            this.submitted = false;
            this.$emit("refreshData");
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response) {
              this.alert.error = error.response.data.detail;
              this.$refs.fadeAlertDanger.show();
              this.submitted = false;
            } else {
              this.alert.error = error.message;
              this.$refs.fadeAlertDanger.show();
              this.submitted = false;
            }
          });
      }
    },
    cancel() {
      this.disconnectFromSSE();
      this.file = null;
      this.$refs.openModal.hide();
    },
    handleFileUpload(e) {
      this.file = e.target.files[0];
    },
    getPosition() {
      navigator.geolocation.getCurrentPosition(this.success, this.error);
    },
    success(pos) {
      var crd = pos.coords;
      this.latitude = crd.latitude;
      this.longitude = crd.longitude;
    },
    error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    },
    tdColor(value, key, item) {
      if (!item.success) return "table-td-bg-red";
      return "table-td-bg-green";
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>